<template>
  <div class="AnswerArea">
    <template v-if="examstatus == 1 && errorStatus === 0 && questioninfo.length == 0">
        <div class="null">
            <img src="~common/images/search/search-null.png" alt="">
            <p>您的考试没有错题！</p>
        </div>
    </template>
    <template v-else>
        <div v-for="(item, index) in questioninfo" :key="index">
            <!-- 1单选题 2多选题 3不定项选择题 4判断题 5填空题 6问答题 -->
            <Radio v-if="item.questiontype == 1" :questionitem="item" :examstatus="examstatus" :isshow="isshow"></Radio>
            <!-- end 单选题 -->

            <Checkbox v-else-if="item.questiontype == 2 || item.questiontype == 3" :questionitem="item" :examstatus="examstatus" :isshow="isshow"></Checkbox>
            <!-- end 多选题、不定项选择题 -->

            <Judge v-else-if="item.questiontype == 4" :questionitem="item" :examstatus="examstatus" :isshow="isshow"></Judge>
            <!-- end 判断题 -->

            <QuestionsAndAnswers v-else-if="item.questiontype == 5" :questionitem="item" :examstatus="examstatus" :isshow="isshow"></QuestionsAndAnswers>
            <!-- end 填空题 -->

            <FillInTheBlanks v-else-if="item.questiontype == 6" :questionitem="item" :examstatus="examstatus" :isshow="isshow" :ischeckover="ischeckover"></FillInTheBlanks>
            <!-- end 问答题 -->
            <Materials v-else-if="item.questiontype == 7" :questionitem="item" :examstatus="examstatus" :isshow="isshow" :ischeckover="ischeckover"/>
            <!-- 材料题 -->
        </div>
        <PageBtn :pageinfo="pageinfo" :examstatus="examstatus"></PageBtn>
        <!-- end 翻页 -->
    </template>

  </div>
</template>

<script>
import Checkbox from './../components/topicTypes/Checkbox'
import FillInTheBlanks from './../components/topicTypes/FillInTheBlanks'
import Judge from './../components/topicTypes/Judge'
import QuestionsAndAnswers from './../components/topicTypes/QuestionsAndAnswers'
import Radio from './../components/topicTypes/Radio'
import PageBtn from './../components/PageBtn'
import Materials from './../components/topicTypes/Materials'

export default {
  name: 'AnswerArea',
  props: ['questioninfo', 'examstatus', 'pageinfo', 'isshow', 'ischeckover'], // 试题信息 试卷提交状态 pageinfo:{pageCount 最大页数 pageNum 当前页数 pageSize 每页显示条数 rowCount 题目总数} isshow 是否显示答案
  data () {
    return {
        page: this.$route.query.page,    // 当前页数
        // questioninfo: [],   // 试题信息答案数组
        questionArray: {    // 试题信息答案对象
            innerid: '',    // 试题id
            questiontype: '',   // 试题类型 传123456
            uselanswer: ''  // 用户答案(选择题多个选项答案用英文逗号组装，填空题多空用|组装，判断题传T和F)
        },
        errorStatus: this.$route.query.status == '0' ? 0:''    // 只看错题状态
    }
  },
  mounted () {
  },
  methods: {
     
  },
  filters: {},
  watch: {
      $route: {
          handler() {
              this.errorStatus = this.$route.query.status == '0' ? 0:''
          }
      }
  },
  computed: {
  },
  components: {
      Checkbox,
      FillInTheBlanks,
      Judge,
      QuestionsAndAnswers,
      Radio,
      PageBtn,
      Materials
  }
}
</script>

<style lang="scss" type="text/scss" scope>
.AnswerArea {
    float: left;
    width: 895px;
    line-height: 1.5;
    .answerarea-item {
        margin-bottom: 20px;
    }
    .null {
        height: 636px;
        background: #fff;
        p {
            font-size: 14px;
            color: #CADAEE;
            text-align: center;
        }
        img {
            display: block;
            width: 115px;
            margin: auto;
            padding-top: 156px;
            margin-bottom: 20px;
        }
    }
    .topic-types {
        padding: 21px 22px;
        box-sizing: border-box;
        background: #fff;
        
        .name,
        .name span {
            font-weight: bold;
        }
        .name span {
            margin-right: 11px;
        }
        .title {
            margin-left: 25px;
            margin-top: 12px;
            padding-right: 35px;
        }
        .option-list {
            margin-top: 5px;
            .option-item {
                margin-top: 15px;

                span {
                    color: #303133;
                    // float: left;
                }
                .option-icon {
                    margin-right: 4px;
                    padding-top: 3px;
                    color: #909399;
                }
                .option-text {
                    width: calc(100% - 80px);
                    white-space: normal;
                    line-height: 1.5;
                }
                .el-radio {
                    width: calc( 100% - 36px);
                    .el-radio__label {
                        width: calc(100% - 40px);
                    }
                    .el-radio__inner {
                        display: inline-block;
                        // margin-top: 5px;
                    }
                }
                .el-checkbox {
                    padding-left: 26px;
                    width: calc( 100% - 36px);
                    
                    .el-checkbox__label {
                        width: calc(100% - 40px);

                        i {
                            position: absolute;
                            left: 0;
                        }
                    }
                    .el-checkbox__inner {
                        display: inline-block;
                        // margin-top: 5px;
                    }
                   
                }
            }
            i {
                float: left;
                padding-top: 7px;
                margin-right: 12px;
                font-weight: bold;
                &.el-icon-check {
                    color: #0ABF53;
                    
                }
                &.el-icon-close {
                    color: #FF4747;
                }
            }
        }

        &.answer {
            padding: 20px 30px;
            border-top: solid 1px #E5E5E5;

            p {
                overflow: hidden;
                span {
                    float: left;
                    &:first-child {
                        color: #909399;
                    }
                    &:last-child {
                        width: calc(100% - 115px);
                        color: #303133;
                    }
                    &.fraction {
                        color: #FF4747;
                    }
                }
                & ~ p {
                    margin-top: 12px;
                }
            }
        }
    }
    .fontsize-18 {
        p,
        span,
        i {
            font-size: 18px !important;
        }
    }
    .fontsize-16 {
        p,
        span,
        i {
            font-size: 16px !important;
        }
    }
    .fontsize-14 {
        p,
        span,
        i {
            font-size: 14px !important;
        }
    }
}
</style>